import { CSSProperties } from 'react';
import { CustomPosition, PresetPosition } from 'src/store/actions/widget';

export const prepareStyle = (position: CustomPosition): CSSProperties => {
	const { top = 'auto', bottom = 'auto', left = 'auto', right = 'auto' } = position;
	return {
		top,
		bottom,
		left,
		right
	};
};

export const getPositionClassName = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	position: any
): PresetPosition | string => {
	const defaultPosition: PresetPosition = PresetPosition.TopLeft;
	// Check if the position is a valid PresetPosition
	if (Object.values(PresetPosition).includes(position)) {
		return position;
	}
	// Check if the position is a valid CustomPosition
	if (
		typeof position === 'object' &&
		('top' in position || 'bottom' in position) &&
		('right' in position || 'left' in position) &&
		'message' in position
	) {
		return `custom message-${position?.message}`;
	}
	// If neither, return the default PresetPosition
	return defaultPosition;
};
